var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New",
    clipPath: "url(#clip0_2687_237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.59087 3.59087 0 8 0C12.4091 0 16 3.59087 16 8C16 12.4091 12.4091 16 8 16C3.59087 16 0 12.4091 0 8ZM1.28719 8C1.28719 11.7013 4.29873 14.7128 8 14.7128C11.7013 14.7128 14.7128 11.7013 14.7128 8C14.7128 4.29873 11.7013 1.28719 8 1.28719C4.29873 1.28719 1.28719 4.29873 1.28719 8ZM7.3562 4.6436H8.64358V7.35617H11.3562V8.64355H8.64358V11.3561H7.3562V8.64355H4.64363V7.35617H7.3562V4.6436Z",
    fill: "#4D1DF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2687_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNews);
export default __webpack_public_path__ + "static/media/add_news.c128e3e083bb26f1e1faa3a593c07baf.svg";
export { ForwardRef as ReactComponent };